export default "__VITE_ASSET__irH07Cb3__"